// src/features/dashboard/hooks/Employee/useWeeklyHoursChart.ts

import {
  useEffect,
  useState,
} from 'react';

import {
  getWeeklyHoursChart,
} from '../../services/Employee/weeklyHoursChart.service';

import {
  useDashboardDate,
} from '../../context/DashboardDateContext';

import {
  formatApiDate,
} from '../../utils/date.utils';

import type {
  WeeklyHoursResponse,
} from '../../types/Employee/weeklyHoursChart.types';

import { AuthSession } from '../../../../utils/authSession';



export const useWeeklyHoursChart = () => {

   const employeeCode = AuthSession.currentEmployee();


  const {
    fromDate,
    toDate,
  } = useDashboardDate();

  const [
    data,
    setData,
  ] =
    useState<WeeklyHoursResponse | null>(
      null,
    );

  const [
    loading,
    setLoading,
  ] =
    useState(true);

  useEffect(() => {

   if (!employeeCode) {
  return;
}

    const fetchData =
      async () => {

        try {

          setLoading(true);

         const response =
  await getWeeklyHoursChart({
    employeeCode,
    fromDate: formatApiDate(fromDate),
    toDate: formatApiDate(toDate),
  });
          setData(
            response,
          );

        } catch (
          error
        ) {

          console.error(
            'Weekly Hours Error:',
            error,
          );

        } finally {

          setLoading(
            false,
          );
        }
      };

    fetchData();

  }, [
    employeeCode,
    fromDate,
    toDate,
  ]);

  return {
    data,
    loading,
  };
};